import {API_BASE_URL} from '../../constants';
import {get, post} from '../api';

export function approveNewUser(requestId: string, approved: boolean) {
  return get(
    `${API_BASE_URL}/userFormular/approveNewUser/${requestId}?approve=${approved}`,
    {
      headers: {'Content-Type': 'application/json'},
    },
  );
}

export function applyForNewUser(data: {[key: string]: string}) {
  return post(`${API_BASE_URL}/userFormular/applyForNewUser`, {
    data: data,
    responseType: 'json',
    headers: {'Content-Type': 'application/json'},
  });
}

export function getCaptcha() {
  return get(`${API_BASE_URL}/userFormular/captcha`);
}

export function getRegisterForm() {
  return get(`${API_BASE_URL}/userFormular/register_form_data`);
}

export function resetPasswordFormular(data: {[key: string]: string}) {
  return post(`${API_BASE_URL}/userFormular/resetPassword`, {
    data: data,
    responseType: 'json',
    headers: {'Content-Type': 'application/json'},
  });
}
